import React, { useMemo, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FixedJobsList } from './FixedJobsList';
import { FixedJobFormDialog } from './FixedJobFormDialog';

interface Props { teacherCode?: string }

export function FixedJobsByWeekday({ teacherCode }: Props) {
  const [activeTab, setActiveTab] = useState<string>('0');
  const [openCreate, setOpenCreate] = useState(false);

  const weekdays = useMemo(() => [
    { key: '0', label: 'อา' },
    { key: '1', label: 'จ' },
    { key: '2', label: 'อ' },
    { key: '3', label: 'พ' },
    { key: '4', label: 'พฤ' },
    { key: '5', label: 'ศ' },
    { key: '6', label: 'ส' },
  ], []);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Fixed Jobs แยกตามวัน</CardTitle>
        <Button onClick={() => setOpenCreate(true)}>เพิ่ม Fixed Job</Button>
      </CardHeader>
      <CardContent>
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid grid-cols-7 w-full">
            {weekdays.map(d => (
              <TabsTrigger key={d.key} value={d.key}>{d.label}</TabsTrigger>
            ))}
          </TabsList>
          {weekdays.map(d => (
            <TabsContent key={d.key} value={d.key}>
              <FixedJobsList teacherCode={teacherCode} weekday={parseInt(d.key, 10)} />
            </TabsContent>
          ))}
        </Tabs>
      </CardContent>

      <FixedJobFormDialog
        open={openCreate}
        onOpenChange={setOpenCreate}
        teacherCode={teacherCode}
      />
    </Card>
  );
}


